import React, { useState, useEffect } from 'react';
import icons from '../utils/icons.json';
import { AnimatePresence, motion } from 'framer-motion';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setAlert } from '../store/alert';

const variants = {
	initial: {
		bottom: -100,
	},
	animate: {
		bottom: 20,
		transition: {
			duration: 0.3,
		},
	},
	exit: {
		bottom: -100,
		transition: {
			duration: 0.3,
		},
	},
};

function Alert() {
	const dispatch = useDispatch();
	const props = useSelector(state => state.alert);

	useEffect(() => {
		let timer = null;
		if (props.message) {
			timer = setTimeout(() => {
				dispatch(setAlert(''));
			}, props.duration || 5000);
		}
		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [props]);

	return (
		<AnimatePresence>
			{props.message && (
				<motion.div onClick={() => dispatch(setAlert(''))} variants={variants} initial='initial' animate='animate' exit={variants.exit} className={`alert shadow ${props.type || 'success'}`}>
					<section className='msg-section'>
						<p className='message'>{props.message}</p>
					</section>
					<section
						className='icon'
						dangerouslySetInnerHTML={{ __html: props.type == 'error' ? icons.times_circle : props.type == 'warning' ? icons.exclamation_circle : icons.check_circle }}></section>
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default React.memo(Alert);
